import { Component, OnInit } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  constructor(
    private dashboardService: DashboardService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private clipboardService: ClipboardService,
    private commonService: CommonService,
  ) { }

  lastMonthCommission: MonthCommission = new MonthCommission()
  avgCommission: MonthCommission = new MonthCommission()
  monthPaymentRanking: PaymentRanking[] = new Array()
  bestProductByPrice: ProductByPrice[] = new Array()
  bestProductByUrl: ProductByPrice[] = new Array()
  userWaitingCount: number = 0
  qnaWaitingCount: number = 0
  userConfirmCount: number = 0
  monthStats: MonthStats = new MonthStats()
  ngOnInit(): void {
    this.dashboardService.getAdminDashboard().subscribe(res => {
      this.lastMonthCommission = res.data.lastMonthCommission
      this.avgCommission = res.data.avgCommission
      this.monthPaymentRanking = res.data.monthPaymentRanking
      if(this.monthPaymentRanking && this.monthPaymentRanking.length > 10) {
        this.monthPaymentRanking = this.monthPaymentRanking.splice(0, 10)
      }
      this.bestProductByPrice = res.data.bestProductByPrice
      this.bestProductByUrl = res.data.bestProductByUrl
      this.userWaitingCount = res.data.userWaitingCount
      this.qnaWaitingCount = res.data.qnaWaitingCount
      this.userConfirmCount = res.data.userConfirmCount
      this.monthStats = res.data.monthStats
    })
  }

}
export class MonthStats {
  buyEventCount: number
  cancelEventCount: number
  clickEventCount: number
  totalPayment: number
  totalPrice: number
  totalBuyPrice: number
  totalCancelPrice: number
}
export class MonthCommission {
  commissionPrice: number
  fromDate: string
  toDate: string
}

export class PaymentRanking {
  userId: string
  userName: string
  userNo: number
  totalPayment: number
  commissionPrice: number
  clickEventCount: number
  buyEventCount: number
  cancelEventCount: number
}

export class ProductByPrice {
  productId: number
  title: string
  filePath: string
  eventCount: number
  totalPrice: number
}